import React from 'react';

import ddcLogo from '../images/nycddc.png';
import benchmarkManual from '../benchmarkManual/BenchmarkManual.pdf';

const Footer = () => (
  <div className="App-footer container">
    <div className="row">
      <div className="col s12 footer-print">
      <img src={ddcLogo} alt="NYC DDC logo" />
        <a href={benchmarkManual} target="_blank" alt="benchmark manual" rel="noopener noreferrer" className="footer-link-manual no-print">View Manual</a>
        <p className="no-print">&copy; {(new Date()).getFullYear()} / New York City Department of Design and Construction /
          All rights reserved. Version: 1.2.0.0
        </p>
        </div>
    </div>
  </div>
);

export default Footer;
